import React, { Component } from "react";
import { Link } from "react-router-dom";
import Topbar from "../topBar";
import Sidebar from "../sideBar";
import Cookies from "universal-cookie";
import { Tooltip } from "react-tooltip";
import { FaImage } from "react-icons/fa";
import { privateApiCall } from "../../api/privateApi";
import CloseIcon from "@mui/icons-material/Close";
import ImageModal from "../../images/imageModal";
import {
  DASHBOARD,
  BUY_PRODUCT,
  VIEW_DET,
  VIEW_IMG,
  FEED,
  REJECT,
} from "../../constants/url";
import {
  ERR_ALERT_TITLE,
  ERR_POSTING,
  SUCC_ALERT_TITLE,
  SUCC_FEEDBACK,
  SUCC_REJECTPRODUCT_TITLE,
  SUCC_REJECTPRODUCT_TXT,
  ERR_GETTING,
} from "../../constants/alertMessage";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Modal,
  Box,
  DialogTitle,
  Grid,
  Typography,
  Button,
  TextField,
  DialogActions,
  Dialog,
} from "@mui/material";

import { FiMessageCircle, FiXCircle, FiEye, FiSearch } from "react-icons/fi";
import Swal from "sweetalert2/dist/sweetalert2.js";

const cookies = new Cookies();
class appList extends Component {
  constructor() {
    const localRole = JSON.parse(localStorage.getItem("role"))
    super();
    this.state = {
      data: "",
      replay: "",
      open: false,
      open1: false,
      open2: false,
      images: [],
      customer: "",
      mobile_no: "",
      title: "",
      feedId: "",
      description: "",
      qty: "",
      unit: "",
      endDate: "",
      startDate: "",
      permissions: localRole && localRole.permissions ? localRole.permissions : "All",
      isSendingFeedback: false 
    };
    this.edit = this.edit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }
  componentDidMount() {
    const requestUrl1 = `${BUY_PRODUCT}/approvedbuylist/`;
    privateApiCall(requestUrl1, "GET")
      .then((res) => {
        const k = 1;
        for (let i = 0; i < res.data.data.length; i++) {
          res.data.data[i].sno = k + i;
        }

        this.setState({ data: res.data.data });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  addSerialNumbers(data) {
    return data.map((item, index) => ({
      ...item,
      sno: index + 1,
    }));
  }

  handleSearch(e) {
    const searchValue = e.target.value;
    const requestUrl = `${BUY_PRODUCT}/search_buy_approved_list?query=${searchValue}&`;

    privateApiCall(requestUrl, "GET")
      .then((response) => {
        if (response.data && response.data.data) {
          const dataWithSerialNumbers = this.addSerialNumbers(
            response.data.data
          );
          this.setState({ data: dataWithSerialNumbers });
        } else {
          this.setState({ data: [] });
        }
      })
      .catch((error) => {
        Swal.fire({
          title: `${ERR_ALERT_TITLE}`,
          text: `${ERR_GETTING}`,
          icon: "error",
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: "OK",
        });
      });
  }

  iconformat(cell, row) {
    return "<img src='" + cell + "' style='height:50px;'/>";
  }

  handleClose = () => {
    this.setState({ open: false });
  };

  handleClose1 = () => {
    this.setState({ open1: false });
  };

  handleClose2 = () => {
    this.setState({ open2: false });
  };

  handleReplay = (event) => {
    event.preventDefault();
    this.setState({ isSendingFeedback: true });
    const agritechToken = cookies.get("agritech_token");

    const requestUrl = `${BUY_PRODUCT}/replayToBProduct/?token=${agritechToken}&_id=${this.state.feedId}&replay=${this.state.replay}`;
    privateApiCall(requestUrl, "GET")
      .then((res) => {
        if (res.data.status) {
          const requestUrl = `${BUY_PRODUCT}/approvedbuylist/`;
          privateApiCall(requestUrl, "GET")
            .then(
              (res) => {
                const k = 1;
                for (let i = 0; i < res.data.data.length; i++) {
                  res.data.data[i].sno = k + i;
                }
                this.setState({
                  open2: false,
                  replay: "",
                  data: res.data.data,
                  isSendingFeedback: false
                });

                Swal.fire({
                  title: `${SUCC_ALERT_TITLE}`,
                  text: `${SUCC_FEEDBACK}`,
                  icon: "success",
                  allowOutsideClick: false,
                  showCancelButton: false,
                  confirmButtonText: "OK",
                });
              },
              (err) => {
                this.setState({ isSendingFeedback: false });
                Swal.fire({
                  title: `${ERR_ALERT_TITLE}`,
                  text: `${ERR_POSTING}`,
                  icon: "error",
                  allowOutsideClick: false,
                  showCancelButton: false,
                  confirmButtonText: "OK",
                });
              }
            )
            .catch((err) => {
              Swal.fire({
                title: `${ERR_ALERT_TITLE}`,
                text: `${ERR_POSTING}`,
                icon: "error",
                allowOutsideClick: false,
                showCancelButton: false,
                confirmButtonText: "OK",
              });
            });
        } else {
          Swal.fire({
            title: `${ERR_ALERT_TITLE}`,
            text: `${ERR_POSTING}`,
            icon: "error",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: "OK",
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          title: `${ERR_ALERT_TITLE}`,
          text: `${ERR_POSTING}`,
          icon: "error",
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: "OK",
        });
      });
  };

  handleChange(event) {
    this.setState({
      replay: event.target.value,
    });
  }

  edit(cell, row, ex, index) {
    const handleImageClick = () => {
      const imagesData = row.image1;

      if (row.image1) {
        this.setState({ images: [row.image1], open: true });
      }

    };
    const isOnlyImage1Present =
      row.image1 !== undefined && row.image1 !== null && row.image1 !== "";

    const handleS = (e) => {
      // Perform the state updates only if confirmed
      this.setState({ feedId: row.id });
      this.setState({ open2: true });
    };
    const handleOnChange = (event) => {
      event.preventDefault();

      Swal.fire({
        title: `Reject ${row.title}`,
        text: "",
        icon: "error",
        allowOutsideClick: false,
        confirmButtonText: "Yes",
        showCancelButton: true,
      })
        .then((result) => {
          if (result.isConfirmed) {
            const requestUrl = `${BUY_PRODUCT}/rejectBuyProduct/${row.id}/`;
            privateApiCall(requestUrl, "GET")
              .then((res) => {
                if (res.status === 200) {
                  var selections = this.state.data;
                  selections.splice(index, 1);

                  this.setState({
                    data: selections,
                  });

                  // Success Swal
                  Swal.fire({
                    title: `${SUCC_REJECTPRODUCT_TITLE}`,
                    text: `${SUCC_REJECTPRODUCT_TXT}`,
                    icon: "success",
                    timer: 1100,
                    showConfirmButton: false,
                  });
                }
              })
              .catch((err) => {
                Swal.fire({
                  title: `${ERR_ALERT_TITLE}`,
                  text: `${ERR_POSTING}`,
                  icon: "error",
                  allowOutsideClick: false,
                  showCancelButton: false,
                  confirmButtonText: "OK",
                });
              });
          }
        })
        .catch(() => {
          Swal.fire({
            title: `${ERR_ALERT_TITLE}`,
            text: `${ERR_POSTING}`,
            icon: "error",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: "OK",
          });
        });
    };

    const handlePOP = (e) => {
      const {
        customer,
        mobile_no,
        name,
        expDate,
        description,
        title,
        qty,
        unit,
        startDate,
        endDate,
        location,
        safe_status,
        organic_status,
        transpot_status,
      } = row;
      this.setState({
        customer: customer,
        mobile_no: mobile_no,
        name: name,
        expDate: expDate,
        description: description,
        title: title,
        qty: qty,
        unit: unit,
        startDate: startDate,
        endDate: endDate,
        location: location,
        safe_status,
        organic_status,
        transpot_status,
      });
      this.setState({ open1: true });
    };
    return (
      <span>
        {this.state.permissions.some(item => item.keyword === "buyProductApprovedList" && item.isReject == true) &&
          <>
            <i className="" data-tooltip-id="1" data-tooltip-content={`${REJECT}`}>
              {" "}
              <FiXCircle onClick={handleOnChange} color="#f36270" size="20" />
            </i>
            <Tooltip id="1" />
          </>
        }
        {this.state.permissions.some(item => item.keyword === "buyProductApprovedList" && item.isFeedback == true) &&
          <>
            {
              row.replay !== "" ? (
                <i
                  className="ml-1"
                  data-tooltip-id="2"
                  data-tooltip-content={`${FEED}`}
                >
                  {" "}
                  <FiMessageCircle onClick={handleS} color="#769A0F" size="20" />
                </i>
              ) : (
                <i
                  className="ml-1"
                  data-tooltip-id="2"
                  data-tooltip-content={`${FEED}`}
                >
                  {" "}
                  <FiMessageCircle onClick={handleS} color="#f9bc0b" size="20" />
                </i>
              )
            }
            <Tooltip id="2" />
          </>
        }
        <i
          className="ml-1"
          data-tooltip-id="3"
          data-tooltip-content={`${VIEW_DET}`}
        >
          {" "}
          <FiEye onClick={handlePOP} color="#9368f3" size="20" />
        </i>
        <Tooltip id="3" />

        {
          isOnlyImage1Present && (
            <i
              className="ml-1"
              data-tooltip-id="4"
              data-tooltip-content={`${VIEW_IMG}`}
            >
              {" "}
              <FaImage onClick={handleImageClick} color="green" size="17" />
            </i>
          )
        }
        <Tooltip id="4" />
      </span >
    );
  }

  render() {
    console.log(this.state.images, "****");
    return (
      <div id="wrapper">
        <Topbar backgroundColor="#769A0F" />
        <Sidebar type="buyProducts" />
        <div className="content-page">
          <div className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box">
                    <h4 className="page-title float-left">
                      Product Enquiries - Approved List
                    </h4>

                    <ol className="breadcrumb float-right">
                      <li className="breadcrumb-item">
                        {" "}
                        <Link to={DASHBOARD}>Dashboard</Link>
                      </li>
                      <li className="breadcrumb-item active">Product Enquiries</li>
                      <li className="breadcrumb-item active">Approved List</li>
                    </ol>

                    <div className="clearfix"></div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card-box">
                    <div
                      style={{
                        width: "98%",
                      }}
                    >
                      <div
                        style={{
                          marginLeft: "auto",
                          width: "200px",
                          marginBottom: "20px",
                          position: "relative",
                        }}
                      >
                        <input
                          type="text"
                          placeholder="Search..."
                          className="form-control"
                          style={{
                            width: "100%",
                            paddingLeft: "30px",
                            boxSizing: "border-box",
                          }}
                          onChange={(e) => {
                            this.handleSearch(e);
                            // Hide the icon if there is text in the input
                            if (e.target.value) {
                              e.target.nextSibling.style.display = "none";
                            } else {
                              e.target.nextSibling.style.display = "block";
                            }
                          }}
                        />
                        <i
                          className="fas fa-search"
                          style={{
                            position: "absolute",
                            left: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#aaa",
                            pointerEvents: "none",
                          }}
                        ></i>
                      </div>

                      <TableContainer component={Paper}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell align="left">S.No</TableCell>
                              <TableCell align="left">Customer</TableCell>
                              <TableCell align="left">Mobile</TableCell>
                              <TableCell align="left">Title</TableCell>

                              <TableCell align="left">Actions</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {Array.isArray(this.state.data) &&
                              this.state.data.map((row, index) => (
                                <TableRow key={index}>
                                  <TableCell align="left">{row.sno}</TableCell>
                                  <TableCell align="left">
                                    {row.customer}
                                  </TableCell>
                                  <TableCell align="left">
                                    {row.mobile_no}
                                  </TableCell>
                                  <TableCell align="left">
                                    {row.title}
                                  </TableCell>

                                  <TableCell align="left">
                                    {this.edit(null, row, null, index)}
                                  </TableCell>
                                </TableRow>
                              ))}
                            <ImageModal
                              handleClose={this.handleClose}
                              open={this.state.open}
                              imageSrc={this.state.images}
                            />

                            <Dialog
                              open={this.state.open1}
                              onClose={this.handleClose1}
                              aria-labelledby="details-modal-title"
                              aria-describedby="details-modal-description"
                              style={{
                                maxHeight: "80vh",
                                overflowY: "auto",
                                marginTop: "100px",
                              }}
                              fullWidth
                              disableEnforceFocus
                              maxWidth="lg"
                            >
                              <Grid
                                container
                                justifyContent="center"
                                alignItems="center"
                                className="modal-content"
                              >
                                <Grid item xs={12} className="modal-header">
                                  <h5 id="details-modal-title">
                                    {" "}
                                    Product Details
                                  </h5>
                                  <Button
                                    onClick={this.handleClose1}
                                    color="inherit"
                                  >
                                    {" "}
                                    <span
                                      style={{ fontSize: "20px" }}
                                      aria-hidden="true"
                                    >
                                      &#128473;
                                    </span>
                                  </Button>
                                </Grid>
                                <Grid item xs={12} className="modal-body">
                                  <Table className="col-12">
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Customer Name
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {this.state.customer}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Customer Mobile
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {this.state.mobile_no}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Product Title
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {this.state.title}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Description
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {this.state.description}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Quantity
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {this.state.qty}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Unit
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {this.state.unit}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Location
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {this.state.location}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Start Date
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {this.state.startDate}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className="text-left">
                                        End Date
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {this.state.endDate}
                                      </TableCell>
                                    </TableRow>
                                  </Table>
                                </Grid>
                                <Grid item xs={12} className="modal-footer">
                                  <Button
                                    onClick={this.handleClose1}
                                    variant="outlined"
                                    color="error"
                                  >
                                    Close
                                  </Button>
                                </Grid>
                              </Grid>
                            </Dialog>
                            <Dialog
                              open={this.state.open2}
                              onClose={this.handleClose2}
                              maxWidth="lg"
                              fullWidth
                              centered
                              disableEnforceFocus
                            >
                              <div
                                style={{
                                  backgroundColor: "#fff",
                                  padding: "20px",
                                  // minWidth: '500px',
                                  borderRadius: "8px",
                                }}
                              >
                                <h3>Feedback</h3>
                                <form onSubmit={this.handleReplay}>
                                  <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                      <div className="text-left text-dark mb-1">
                                        Message
                                      </div>
                                      <TextField
                                        type="text"
                                        fullWidth
                                        multiline
                                        rows={4}
                                        variant="outlined"
                                        value={this.state.replay}
                                        placeholder="Message"
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </Grid>
                                  </Grid>
                                  <Grid
                                    container
                                    justifyContent="flex-end"
                                    style={{ marginTop: "20px" }}
                                  >
                                    <Button
                                      variant="outlined"
                                      color="error"
                                      onClick={this.handleClose2}
                                      style={{ marginRight: "8px" }}
                                    >
                                      Close
                                    </Button>
                                    <Button
                                      type="submit"
                                      variant="contained"
                                      disabled={this.state.isSendingFeedback}
                                      style={{
                                        backgroundColor: "#769A0F",
                                        color: "#fff",
                                      }}
                                    >
                                      {this.state.isSendingFeedback ? "Sending..." : "Send"}
                                    </Button>
                                  </Grid>
                                </form>
                              </div>
                            </Dialog>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default appList;
